// extracted by mini-css-extract-plugin
export default {"field":"Field_field__LVdif","left":"Field_left__8iZNI","right":"Field_right__BLSoW"};